<template>
  <div class="fundingNeedsInfo">
    <review-card name="fundingNeedsInfoEdit" :editable="false">
      <template #title>{{ t('title') }}</template>

      <div class="data">
        <text-object :label="t('loanAmountLabel')">
          {{ formatMoney(application.requestedAmount ? application.requestedAmount: '0' ) }}
        </text-object>
        <text-object :label="t('fundingPurposesLabel')">
          {{ fundingPurposes }}
        </text-object>
      </div>
    </review-card>
  </div>
</template>
<script>
import { OTHER } from '@/modules/funds';
import ReviewCard from '@/components/ReviewCard';
import TextObject from '@/components/TextObject';
import buildTranslators from '@/utils/build-translators';
import money from '@/filters/money';

export default {
  name: 'funding-needs-info',
  components: {
    ReviewCard,
    TextObject,
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fundingPurposes() {
      const fundings = this.application.fundingPurposes? this.application.fundingPurposes.map(type => {
        return type === OTHER
          ? this.application._extension.fundingPurposesOther
          : this.$t(`fundingNeeds.fundings.${type}`);
      }) : '[]';
      return fundings.join(', ');
    },
  },
  methods: {
    formatMoney: money,
    t(key, options) {
      return buildTranslators('reviewSubmit.card.fundingNeedsInfo').t(key, options);
    },
  },
};
</script>
<style lang="sass" scoped>
.data
  display: grid
  grid-template-columns: repeat(2, minmax(0, 1fr))
  row-gap: $glass-spacing-4
  column-gap: $glass-spacing-3

  +mq($stego)
    grid-template-columns: repeat(3, minmax(0, 1fr))
</style>
